import type { CSSProperties } from '@actual-app/components/styles';

import { TransferPositiveIndicator } from '#components/budget/BalanceWithCarryover';

type MobileSheetTransferPositiveIndicatorProps = {
  style?: CSSProperties;
};

export function MobileSheetTransferPositiveIndicator({
  style,
}: MobileSheetTransferPositiveIndicatorProps) {
  return (
    <TransferPositiveIndicator
      style={{
        width: 15,
        height: 15,
        display: 'inline-flex',
        position: 'relative',
        ...style,
      }}
    />
  );
}
